var _style, _path, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 -4 20 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B2A6C5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,1.3C8.7,1.3,7.5,1.6,6.4,2c-1.4,0.4-3,1.6-3,1.6C1.9,4.7,0.7,6.3,0,8.1c1.6,3.9,5.5,6.7,10,6.7 c4.2,0,7.8-1.9,10-6.7l-5.8,1.7c-0.6,1.7-2.3,3-4.2,3c-2.5,0-4.5-2.1-4.5-4.6c0,0,0,0,0,0c0,0,0,0,0,0c0-0.3,0-0.5,0.1-0.8 c0-0.1,0-0.2,0.1-0.3c0,0,0,0,0,0C6.1,5,7.9,3.5,10,3.5c2.2,0,4,1.6,4.5,3.7c0.1,0.3,0.1,0.6,0.1,0.9c0,0,0,0,0,0c0,0,0,0,0,0 c0,0.6-0.1,1.1-0.3,1.6l2.6,2.6c1.4-1.1,2.5-2.6,3.1-4.2C18.4,4.1,14.5,1.3,10,1.3z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 10,
    cy: 8.1,
    r: 2.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show-password-icon.9958dfa5e38f3f38d8d5f764fbbe0b33.svg";
export { ForwardRef as ReactComponent };